import api from '../../libs/api'
import { getP } from 'redux-polyglot'

export const loadTypes = () => dispatch => {
	  return Promise.all([
    	dispatch(loadTicketTypes())
  		])
}


export const FETCH_TICKET_TYPES_REQUEST = 'TICKET_NEW/FETCH_TICKETS_REQUEST'
export const FETCH_TICKET_TYPES_SUCCESS = 'TICKET_NEW/FETCH_TICKETS_SUCCESS'
export const FETCH_TICKET_TYPES_FAILURE = 'TICKET_NEW/FETCH_TICKETS_FAILURE'

export const fetchTicketTypesRequest = () => ({
	type: FETCH_TICKET_TYPES_REQUEST
})

export const fetchTicketTypesSuccess = (ticketTypesContainer) => {
	
	let types = []
	if (ticketTypesContainer.length > 0) {
		ticketTypesContainer.forEach((type) => {
			types.push({
				id: type.id,
				title: type.title
	 		})
		})
	}
	return {
		type: FETCH_TICKET_TYPES_SUCCESS,
		payload: {
			types
		}
	}
}

export const fetchTicketTypesFailure = (error) => ({
	type: FETCH_TICKET_TYPES_FAILURE,
	payload: error instanceof Error? error : new Error(error),
	error:true
})


export const STEP_ONE_FOCUS_POSITION = 'TICKET_NEW/STEP_ONE_FOCUS_POSITION'
export const STEP_ONE_FOCUS = 'TICKET_NEW/STEP_ONE_FOCUS'
export const STEP_ONE_SELECT = 'TICKET_NEW/STEP_ONE_SELECT'

export const focusPositionStepOneRequest = (position) => ({
	type:STEP_ONE_FOCUS_POSITION,
	payload:{
		position
	}
})

export const focusTypePositionStepOne = pos => (dispatch, getState) => {
	    dispatch(focusPositionStepOneRequest(pos))
}

export const stepOneSelectRequest = (id) => ({
	type:STEP_ONE_SELECT,
	payload:{
		id
	}
})

export const stepOneSelect = id => (dispatch, getState) => {
	
	    dispatch(stepOneSelectRequest(id))
}


export const focusStepOneRequest = (id) => ({
	type:STEP_ONE_FOCUS,
	payload:{
		id
	}
})

export const focusTypeStepOne = id => (dispatch, getState) => {
	    dispatch(focusStepOneRequest(id))
}


export const loadTicketTypes = () => (dispatch, getState) => {
	dispatch(fetchTicketTypesRequest())
	return api.getTicketsTypes()
		.then(res =>  res.json())
		.then(response => {
	          if (response.status === 200) {
	            return dispatch(fetchTicketTypesSuccess(response.tickets_type))
	          } else {
	            return dispatch(fetchTicketTypesFailure(response.reason))
	          }
	        },
	        () =>  dispatch(fetchTicketTypesFailure(getP(getState()).t("support_app.error_loading_ticket_types",{_:'An error occurred while retrieving ticket types'})))
		)
}

export const DISMISS_ERROR = 'TICKET_NEW/DISMISS_ERROR'
export const dismissError = () => ({
  type: DISMISS_ERROR
})
